// extracted by mini-css-extract-plugin
export default {"wrapper":"password-change_wrapper__TaUA7","title":"password-change_title__I59jK","boxInput":"password-change_boxInput__MQpj4"};